module.exports = __webpack_public_path__ + "img/banner.ed287e16.png";